import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./sidenav.css";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { clearAuth } from "../../store/slices/authSlice";

interface NavItem {
  icon: string;
  path: string;
  label: string;
  alt: string;
  className?: string;
}

export const SideNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  const navItems: NavItem[] = [
    {
      icon: "ti-layout-dashboard",
      path: "/dashboard",
      label: "Dashboard",
      alt: "Dashboard",
    },
    {
      icon: "ti-clipboard-text",
      path: "/past-submissions",
      label: "Past Submissions",
      alt: "Past Submissions",
    },
    {
      icon: "ti-calendar",
      path: "/roster",
      label: "Roster",
      alt: "Roster",
    },
    {
      icon: "ti-file-text",
      path: "/pitch/create",
      label: "Pitch Form",
      alt: "Pitch Form",
    },
    
  ];

  // Insert "Subscriptions" after "Past Submissions" (index 1)
  if (user?.role === "admin") {
    navItems.splice(2, 0, {
      icon: "ti-cash-register",
      path: "/transactions",
      label: "Transactions",
      alt: "Transaction",
    });

    navItems.push({
      icon: "ti-label-important",
      path: "/labels",
      label: "Labels",
      alt: "Labels",
    });
  }

  // if (user?.role !== "admin") {
  //   navItems.push({
  //     icon: "ti-brand-google-analytics",
  //     path: "/dsp",
  //     label: "DSP's",
  //     alt: "DSP",
  //   });
  // }

  navItems.splice(navItems.length, 0, {
      icon: "ti-settings",
      path: "/settings",
      label: "Settings",
      alt: "Settings",
    },)

  const handleLogout = () => dispatch(clearAuth());

  return (
    <>
      {/* Mobile Top Bar */}
      <div className="mobile-header">
        <img
          src="/images/logo.png"
          alt="Cadence Logo"
          className="mobile-logo"
        />
        <button className="hamburger" onClick={toggleMenu}>
          ☰
        </button>
      </div>

      {/* Side Navigation */}
      <div className={`side-nav ${isOpen ? "open" : ""}`}>
        <img src="/images/logo.png" alt="Cadence Logo" className="logo" />
        <nav className="nav-list">
          {navItems.map((item, index) => (
            <div
              key={index}
              className={`nav-item-container ${item.className || ""} ${
                location.pathname === item.path ? "active" : ""
              }`}
            >
              <div
                className="nav-item"
                onClick={() => {
                  navigate(item.path);
                  setIsOpen(false); // Close on mobile
                }}
                role="button"
                tabIndex={0}
              >
                <i className={`ti text-white text-xl mr-1 ${item.icon}`}></i>
                <span className="nav-label">{item.label}</span>
              </div>
            </div>
          ))}
          <div className="nav-item-container nav-bottom">
            <div className="nav-item" onClick={handleLogout} role="button">
              <img
                src="/images/signout.png"
                alt="Logout"
                className="nav-icon"
              />
              <span className="nav-label">Logout</span>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default SideNav;
